export const trimObjectFields = (obj: any) => {
    const res = {};
    
    Object.keys(obj).forEach(key => {
        if (obj[key] && typeof obj[key] === 'string') {
            res[key] = obj[key].trim();
        } else {
            res[key] = obj[key];
        }
    });

    return res;
};